type ListCardProps = {
    onClick?: () => void
    className?: string
    children: React.ReactNode
}

const ListCard = (props: ListCardProps) => {
    const { onClick, className, children } = props

    return (
        <div
            onClick={() => onClick && onClick()}
            className={`py-2 px-4 cursor-pointer border-2 border-purple-lightest rounded ${className ?? ''}`}
        >
            {children}
        </div>
    )
}

export default ListCard
